import { render } from "./ProfileLocationsComponent.vue?vue&type=template&id=9d3a70ae&scoped=true"
import script from "./ProfileLocationsComponent.vue?vue&type=script&lang=js"
export * from "./ProfileLocationsComponent.vue?vue&type=script&lang=js"

import "./ProfileLocationsComponent.vue?vue&type=style&index=0&id=9d3a70ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9d3a70ae"

export default script